import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

// MUI
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

// Custom
import AppPage from '@/ui/AppPage/AppPage';
import Permissions from '@/lib/permissions';
import UserContext, { UserContextType } from '@/context/UserContext/UserContext';
import TenantContext, { TenantContextType } from '@/context/TenantContext/TenantContext';
import Upitnik from './Upitnik';

const UpitnikPage = () => {
  const { token } = useParams();
  const userContext = useContext(UserContext) as UserContextType;
  const tenantContext = useContext(TenantContext) as TenantContextType;

  // no header (and no way to the login) unless the tenant has a public geoportal
  const isPublic = localStorage.getItem('auth_token') === tenantContext.publicToken;
  const hideHeader = isPublic && !userContext.hasAnyPermission([Permissions.Public]);

  return (
    <AppPage hideNavDrawer hideHeader={hideHeader} titlett="groblja:upitnik.title">
      <Box my={2}>
        <Container maxWidth="sm" disableGutters sx={{ px: 1 }}>
          <Upitnik token={token || ''} />
        </Container>
      </Box>
    </AppPage>
  );
};

export default UpitnikPage;
